import { collapsedContentFrameDetails } from 'features/Frames/components/Frames/FramesTable/components/TableCollapsedContentDetails/utils/collapsedContentFrameDetails';
import { Frame } from 'features/Frames/types';

export const getValidFrameDetails = (frame: Frame) =>
  collapsedContentFrameDetails.filter((detail) => {
    const frameDetail = frame[detail.key as keyof Omit<Frame, 'status'>];
    return frameDetail && frameDetail !== '0';
  });
